import { post } from './client';

export async function sendContactForm(
  contact_form: Record<string, any>
): Promise<any> {
  return post('/contacts', contact_form);
}
